import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "lnr-map",
  "use": "lnr-map-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"lnr-map\"><path d=\"M18.763 1.075a.5.5 0 0 0-.486-.022l-5.776 2.888-5.776-2.888a.502.502 0 0 0-.447 0l-6 3a.5.5 0 0 0-.276.447v15a.5.5 0 0 0 .724.447l5.776-2.888 5.776 2.888c.141.07.307.07.447 0l6-3a.5.5 0 0 0 .276-.447v-15a.5.5 0 0 0-.237-.425zM6 16.191l-5 2.5V4.809l5-2.5v13.882zM7 2.309l5 2.5v13.882l-5-2.5V2.309zm11 13.882-5 2.5V4.809l5-2.5v13.882z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol